import React from 'react';
import { toast } from 'react-toastify';

import ImportDataForm from 'components/ImportData';
import { useEntityCustomFieldsByRecordType } from 'views/fieldConfigs/hooks/useCustomFieldsByRecordType';
import { entitiesName } from 'views/CRM/shared/utils/entitiesName';
import { POSSIBLE_FILTERS_ENTITIES } from 'hooks/useMemorizeInputsFilters';
import { RegexUtils } from 'utils/fuctions/regexFunctions';
import ContactService from '../../../services/contactService';
import { defaultImportFields } from 'components/ImportData/data/fields';

const ImportContactsModal = ({ isOpen, setIsOpen, recordTypeId, callback }) => {
  const { getCustomFields } = useEntityCustomFieldsByRecordType(
    entitiesName.CONTACT,
    recordTypeId
  );

  const validateContactData = (processedData, originalData, mapping) => {
    const invalidRowsInfo = [];
    const validData = [];
    const phonesInFile = [];

    const reverseMapping = {};
    Object.entries(mapping).forEach(([fieldName, value]) => {
      if (typeof value === 'object' && value !== null) {
        if (value.number) reverseMapping[`${fieldName}_number`] = value.number;
      } else {
        reverseMapping[fieldName] = value;
      }
    });

    processedData.forEach((item, index) => {
      let isRowInvalid = false;
      const rowNumber = index + 1;

      if (!item.name || item.name.length > 100) {
        invalidRowsInfo.push({
          index: rowNumber,
          column: reverseMapping.name || 'Nome',
          message: 'Campo com mais de 100 caracteres ou vazio'
        });
        isRowInvalid = true;
      }

      if (item.phone?.number) {
        const formattedPhone = RegexUtils.removeNumbers(
          RegexUtils.removeSpaces(item.phone.number)
        );

        if (formattedPhone.length < 8) {
          invalidRowsInfo.push({
            index: rowNumber,
            column: reverseMapping.phone_number || 'Telefone',
            message: 'O telefone do cliente está incompleto'
          });
          isRowInvalid = true;
        } else if (phonesInFile.includes(formattedPhone)) {
          invalidRowsInfo.push({
            index: rowNumber,
            column: reverseMapping.phone_number || 'Telefone',
            message: 'O telefone do cliente está duplicado'
          });
          isRowInvalid = true;
        } else {
          phonesInFile.push(formattedPhone);
          item.phone.number = formattedPhone;
        }
      } else {
        invalidRowsInfo.push({
          index: rowNumber,
          column: reverseMapping.phone_number || 'Telefone',
          message: 'O telefone do cliente está vazio'
        });
        isRowInvalid = true;
      }

      if (!isRowInvalid) {
        validData.push(item);
      }
    });

    return { validData, invalidRowsInfo };
  };

  const handleSuccess = (response) => {
    const importedContacts = response?.data?.data?.contacts;
    const { existingContacts, createdContacts, rejectedContacts } =
      importedContacts || {};

    const existingTotal = existingContacts?.length || 0;
    const createdTotal = createdContacts?.length || 0;
    const rejectedTotal = rejectedContacts?.length || 0;
    const total = existingTotal + createdTotal;

    let msg = `${total} contato(s) importado(s). ${existingTotal} contato(s) já existente(s) e ${createdTotal} contato(s) criado(s)`;

    if (rejectedTotal > 0) {
      msg += `, ${rejectedTotal} contato(s) rejeitado(s).`;
      toast.error(`${rejectedTotal} contato(s) rejeitado(s).`);
    }

    toast.success(msg);

    if (callback) {
      callback();
    }
  };

  return (
    <ImportDataForm
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      recordTypeId={recordTypeId}
      importService={ContactService.importContacts}
      defaultFields={defaultImportFields.CRM_CONTACT}
      filterEntity={POSSIBLE_FILTERS_ENTITIES.CRM_CONTACT_IMPORT}
      getCustomFields={getCustomFields}
      showUpdateExistingOption
      validateData={validateContactData}
      onImportSuccess={handleSuccess}
    />
  );
};
export default ImportContactsModal;
